import * as React from 'react';
import styled from 'styled-components';

const ListItemContainer = styled.div<{ selected?: boolean }>`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--color-separator);
  &:last-child {
    border-bottom-color: transparent;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ClickableListItemContainer = styled(ListItemContainer as any)`
	cursor: pointer;
	transition: background-color 0.25s ease-in-out;
	background-color: ${(props: IProps): string => {
    return props.selected ? 'var(--color-list-item-hover);' : 'inherit;';
  }}

	&:hover {
		background-color: var(--color-list-item-hover);
	}
`;

interface IProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
  selected?: boolean;
  innerRef?: React.Ref<HTMLDivElement>;
  role?: string;
}

export const ListItem = (props: IProps): React.ReactElement => {
  const Wrapper = props.onClick
    ? ClickableListItemContainer
    : ListItemContainer;

  return (
    <Wrapper
      ref={props.innerRef}
      style={props.style}
      onClick={props.onClick}
      selected={props.selected}
      role='row'
    >
      {props.children}
    </Wrapper>
  );
};

export const ListItemCell = styled.div.attrs({
  role: 'cell',
})`
  align-items: center;
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  min-width: 0;
  flex-wrap: wrap;
  &:last-child {
    flex: 1;
    justify-content: flex-end;
  }
  &:last-child {
    &:not(:only-child) {
      flex: 1;
    }
  }
  &:only-child {
    justify-content: flex-start;
  }
`;

export const ListItemSafeText = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
